import React from "react";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import ClearIcon from "@mui/icons-material/Clear";
import { IconButton } from "@mui/material";
import parse from "html-react-parser";
import ScrollBar from "components/scrollbar";

const style = {
  event: {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: "90%",
    height: "max-content",
    maxHeight: 1000,
    maxWidth: 1000,
    minWidth: 350,
    bgcolor: "background.paper",
    boxShadow: 24,
    p: 4,
    pt: 2,
  },
};

export default function EmailModal({ open, setOpen, message }) {
  const handleClose = () => setOpen(false);

  return (
    <div>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        id="modal">
        <Box sx={style.event}>
          <div className="d-flex justify-content-end">
            <IconButton className="p-0" size="small" onClick={handleClose}>
              <ClearIcon className="p-0" fontSize="small" />
            </IconButton>
          </div>
          <ScrollBar emailModal={true}>
            <div className="pb-2">
              {" "}
              <span className="font-weight-bold">From</span> : {message?.From}
            </div>
            <div className="pb-2">
              {" "}
              <span className="font-weight-bold">To</span> : {message?.To}
            </div>
            <div className="pb-2">
              {" "}
              <span className="font-weight-bold">Subject</span> :{" "}
              {message?.subject}
            </div>

            <div className="font-weight-bold">Message</div>
            <div className="d-flex justify-content-between">
              {message?.body && parse(message?.body)}
            </div>
          </ScrollBar>
        </Box>
      </Modal>
    </div>
  );
}
